module.exports = __webpack_public_path__ + "css/Bodymap.css.1152fcbdf62e45bfc82e16970a1c8ef7.css";